import React, { useState, useEffect } from "react";
import {
  ThinTextField,
  ThinDropdownWithSearch,
} from "../common/GeneralComponent";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { fetchData } from "../../utils/functions";
import Select from "react-select";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom"

const InfrastructureForm = (props) => {
    const { id } = useParams();
const navigate = useNavigate();
  const { data, schoolProfileId, onUpdate } = props;
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDqaApproved, setIsDqaApproved] = useState(false);
  const [isDqaRejected, setIsDqaRejected] = useState(false);

    const [isFetching, setIsFetching] = useState(false);
    const [loader, setLoader] = useState(false);

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    building_ownership: "",
    structure_type: "",
    condition: "",
    total_rooms: "",
    classrooms: "",
    classrooms_in_use: "",
    classrooms_in_use_repairable: "",
    classrooms_in_use_cost: "",
    classrooms_nonfunctional: "",
    classrooms_nonfunctional_repairable: "",
    classrooms_nonfunctional_cost: "",
    classes_in_open: "",
    classes_in_open_count: "",
    boundary_wall: "",
    boundary_wall_repairable: "",
    boundary_wall_cost: "",
    classroom_door: "",
    classroom_door_count: "",
    classroom_doors_repairable: "",
    classroom_door_cost: "",
    classroom_windows: "",
    classroom_windows_count: "",
    classroom_windows_repairable: "",
    classroom_windows_cost: "",
    electricity: "",
    electricity_connection: "",
    water_source: "",
    water_storage: "",
    water_storage_other: "",
    year_round_water: "",
    handwashing_facility: "",
    handwashing_status: "",
    girls_latrines: "",
    total_toilets: "",
    toilets_functional: "",
    toilets_nonfunctional: "",
    toilets_repair_cost: "",
    drainage: "",
    ventilation: "",
    furniture_ratio: "",
    board_type: [],
    first_aid: "",
    first_aid_status: "",
    fire_safety: [],
  });


   const fetchSchoolAssessment = async () => {
      try {
        setLoader(true);
        setIsFetching(true);
  
        const response = await fetchData(
          `school-fetchById/${id}`,
          "GET",
          null,
          {},
          {},
          navigate
        );
  
        if (response?.data) {
          // setSchoolData(response.data);
  
          // Check for DQA approval at root level
          const isDqaApproved =
            response.data?.SchoolProfile.verified_from_dqa === 1 ||
            response.data?.SchoolProfile.verified_from_dqa === "1";
            
          const isDqaRejected =
            response.data?.SchoolProfile.verified_from_dqa === 2 ||
            response.data?.SchoolProfile.verified_from_dqa === "2";
  
          setIsDqaApproved(isDqaApproved);
          setIsDqaRejected(isDqaRejected);
        }
      } catch (error) {
        console.error("Error fetching school data:", error);
        toast.error("Failed to load school data.");
      } finally {
        setLoader(false);
        setIsFetching(false);
      }
    };
  
    useEffect(() => {
      fetchSchoolAssessment();
    }, [id]);
  //Yup schema for validation
  const validationSchema = Yup.object().shape({
    building_ownership: Yup.string().required("Building Ownership is required"),
    structure_type: Yup.string().required("Structure Type is required"),
    condition: Yup.string().required("Condition is required"),
    total_rooms: Yup.number()
      .typeError("Total rooms is required")
      .min(0, "Value cannot be negative")
      .required("Total Rooms is required"),
    classrooms: Yup.number()
      .typeError("Classrooms is required")
      .min(0, "Value cannot be negative")
      .max(99, "Classrooms cannot be more than 2 digits")
      .test(
        "classrooms-less-than-rooms",
        "Classrooms cannot be greater than Total Rooms",
        function (value) {
          const { total_rooms } = this.parent; // access sibling field
          if (!value || !total_rooms) return true; // skip if empty, Yup required will catch
          return Number(value) <= Number(total_rooms);
        }
      )
      .required("Classrooms is required"),

    classrooms_in_use: Yup.number()
      .typeError("Classrooms in use is required")
      .min(0, "Value cannot be negative")
      .max(99, "Cannot be more than 2 digits")
      .test(
        "in-use-less-than-total-rooms",
        "Classrooms in use cannot be greater than Total Rooms",
        function (value) {
          const { total_rooms } = this.parent;
          if (!value || !total_rooms) return true;
          return Number(value) <= Number(total_rooms);
        }
      )
      .required("Classrooms in Use is required"),
    classrooms_nonfunctional: Yup.number()
      .typeError("Non-functional Classrooms is required")
      .min(0, "Value cannot be negative")
      .required("Non-functional Classrooms is required"),
    classes_in_open: Yup.string().required("Classes in Open is required"),
    boundary_wall: Yup.string().required("Boundary Wall is required"),
    classroom_door: Yup.string().required("Classroom Door is required"),
    classroom_windows: Yup.string().required("Classroom Windows is required"),
    electricity: Yup.string().required("Electricity is required"),
    water_source: Yup.string().required("Water Source is required"),
    water_storage: Yup.string().required("Water Storage is required"),
    year_round_water: Yup.string().required("Year-round Water is required"),
    handwashing_facility: Yup.string().required(
      "Handwashing Facility is required"
    ),
    girls_latrines: Yup.string().required("Girls Latrines is required"),
    total_toilets: Yup.number()
      .min(0, "Value cannot be negative")
      .typeError("Total Toilets is required"),

    // Replace the existing toilets_functional and toilets_nonfunctional validations with:

    toilets_functional: Yup.number()
      .transform((val, orig) => (orig === "" ? undefined : val))
      .required("Functional Toilets is required")
      .min(0, "Value cannot be negative")
      .test(
        "toilets-sum-match",
        "Functional + Non-functional toilets must equal Total toilets",
        function (value) {
          const { total_toilets, toilets_nonfunctional } = this.parent;
          if (!value || !total_toilets || !toilets_nonfunctional) return true;
          return (
            Number(value) + Number(toilets_nonfunctional) ===
            Number(total_toilets)
          );
        }
      ),

    toilets_nonfunctional: Yup.number()
      .transform((val, orig) => (orig === "" ? undefined : val))
      .required("Non-functional Toilets is required")
      .min(0, "Value cannot be negative")
      .test(
        "toilets-sum-match",
        "Functional + Non-functional toilets must equal Total toilets",
        function (value) {
          const { total_toilets, toilets_functional } = this.parent;
          if (!value || !total_toilets || !toilets_functional) return true;
          return (
            Number(value) + Number(toilets_functional) === Number(total_toilets)
          );
        }
      ),

    total_toilets: Yup.number()
      .required("Total Toilets is required")
      .min(0, "Value cannot be negative")
      .typeError("Total Toilets is required")
      .test(
        "toilets-sum-match",
        "Total toilets must equal Functional + Non-functional toilets",
        function (value) {
          const { toilets_functional, toilets_nonfunctional } = this.parent;
          if (!value || !toilets_functional || !toilets_nonfunctional)
            return true;
          return (
            Number(value) ===
            Number(toilets_functional) + Number(toilets_nonfunctional)
          );
        }
      ),

    drainage: Yup.string().required("Drainage is required"),
    ventilation: Yup.string().required("Ventilation is required"),
    furniture_ratio: Yup.string().required("Furniture Ratio is required"),

    board_type: Yup.array()
      .min(1, "Select at least one Board Type")
      .required("Board Type is required"),

    fire_safety: Yup.array()
      .of(Yup.string())
      .min(1, "Select at least one Fire Safety option"),

    first_aid: Yup.string().required("First Aid is required"),

    electricity_connection: Yup.string().when("electricity", {
      is: "Yes",
      then: (s) =>
        s.required(
          "Electricity Connection Type is required when Electricity is Yes"
        ),
    }),

    water_storage_other: Yup.string().when("water_storage", {
      is: "Others",
      then: (s) => s.required("Please specify water storage type"),
    }),

    handwashing_status: Yup.string().when("handwashing_facility", {
      is: "Yes",
      then: (s) => s.required("Handwashing Facility Status is required"),
    }),

    classroom_windows_repairable: Yup.string().when("classroom_windows", {
      is: "Yes",
      then: (s) => s.required("Classroom Windows Repairable is required"),
    }),
    //Update cost field validations in Yup schema
    classrooms_in_use_cost: Yup.mixed().when("classrooms_in_use_repairable", {
      is: "Yes",
      then: () =>
        Yup.number()
          .typeError("Functional Est. Repair Cost must be a valid number")
          .required("Functional Est. Repair Cost is required")
          .min(0, "Cost cannot be negative")
          .max(9999999, "Cost cannot exceed 7 digits"),
      otherwise: () => Yup.mixed().nullable(),
    }),

    classrooms_nonfunctional_cost: Yup.mixed().when(
      "classrooms_nonfunctional_repairable",
      {
        is: "Yes",
        then: () =>
          Yup.number()
            .typeError("Non-Functional Est. Repair Cost must be a valid number")
            .required("Non-Functional Est. Repair Cost is required")
            .min(0, "Cost cannot be negative")
            .max(9999999, "Cost cannot exceed 7 digits"),
        otherwise: () => Yup.mixed().nullable(),
      }
    ),

    boundary_wall_repairable: Yup.string().when("boundary_wall", {
      is: "Yes",
      then: (s) => s.required("Boundary Wall Repairable is required"),
    }),

    boundary_wall_cost: Yup.mixed().when("boundary_wall_repairable", {
      is: "Yes",
      then: () =>
        Yup.number()
          .typeError("Cost must be a number")
          .required("Boundary Wall Cost is required")
          .min(0, "Cost cannot be negative")
          .max(9999999, "Cost cannot exceed 7 digits"),
      otherwise: () => Yup.mixed().nullable(),
    }),

    classroom_door_cost: Yup.number()
      .typeError("Cost must be a number")
      .min(0, "Cost cannot be negative")
      .max(9999999, "Cost cannot exceed 7 digits")
      .nullable(),

    classroom_windows_cost: Yup.number()
      .typeError("Cost must be a number")
      .min(0, "Cost cannot be negative")
      .max(9999999, "Cost cannot exceed 7 digits")
      .nullable(),

    toilets_repair_cost: Yup.number()
      .typeError("Cost must be a number")
      .min(0, "Cost cannot be negative")
      .max(9999999, "Cost cannot exceed 7 digits")
      .nullable(),
  });

  // Convert boolean values to "Yes"/"No" strings for dropdowns
  const booleanToYesNo = (value) => {
    if (value === true) return "Yes";
    if (value === false) return "No";
    return "";
  };

  //Load API data into form when data prop changes
  useEffect(() => {
    if (data) {
      setFormData({
        building_ownership: data.building_ownership || "",
        structure_type: data.structure_type || "",
        condition: data.condition || "",
        total_rooms: String(data.total_rooms ?? ""),
        classrooms: String(data.total_classrooms ?? ""),
        classrooms_in_use: String(data.classrooms_functional ?? ""),
        classrooms_in_use_repairable: booleanToYesNo(
          data.classrooms_functional_repairable
        ),
        classrooms_in_use_cost: String(
          data.classrooms_functional_repair_cost || ""
        ),
        classrooms_nonfunctional: String(data.classrooms_non_functional ?? ""),
        classrooms_nonfunctional_repairable: booleanToYesNo(
          data.classrooms_non_functional_repairable
        ),
        classrooms_nonfunctional_cost: String(
          data.classrooms_non_functional_repair_cost || ""
        ),
        classes_in_open: booleanToYesNo(data.classes_in_open),
        classes_in_open_count: String(data.classes_in_open_count || ""),
        boundary_wall: booleanToYesNo(data.boundary_wall),
        boundary_wall_repairable: booleanToYesNo(data.boundary_wall_repairable),
        boundary_wall_cost: String(data.boundary_wall_repair_cost || ""),
        classroom_door: booleanToYesNo(data.classroom_doors),
        classroom_door_count: String(data.classroom_doors_count || ""),
        classroom_doors_repairable: booleanToYesNo(
          data.classroom_doors_repairable
        ),
        classroom_door_cost: String(data.classroom_doors_repair_cost || ""),
        classroom_windows: booleanToYesNo(data.classroom_windows),
        classroom_windows_count: String(data.classroom_windows_count || ""),

        electricity: booleanToYesNo(data.electricity_available),
        electricity_connection: data.electricity_connection_type || "",
        water_source: data.water_source || "",
        water_storage: data.water_storage_type || "",
        water_storage_other: data.water_storage_type_other || "",
        year_round_water: booleanToYesNo(data.water_available_year_round),
        handwashing_facility: booleanToYesNo(data.handwashing_facility),
        handwashing_status: data.handwashing_functional
          ? "Functional"
          : "Non-Functional",
        girls_latrines: booleanToYesNo(data.separate_girls_latrines),
        total_toilets: String(data.total_toilets ?? ""),
        toilets_functional: String(data.functional_toilets ?? ""),
        toilets_nonfunctional: String(data.non_functional_toilets ?? ""),
        toilets_repair_cost: String(data.toilets_repair_cost || ""),
        drainage: data.drainage || "",
        ventilation: data.ventilation_lighting || "",
        furniture_ratio: data.furniture_ratio || "",
        board_type: data.board_types ? data.board_types.split(",") : [],
        fire_safety: data.fire_safety ? data.fire_safety.split(",") : [],
        first_aid: booleanToYesNo(data.first_aid_box),
        first_aid_status: data.first_aid_supplies || "",
        classroom_windows_repairable: booleanToYesNo(
          data.classroom_windows_repairable
        ),
        classroom_windows_cost: String(
          data.classroom_windows_repair_cost || ""
        ),
      });
    }
  }, [data]);
  const handleCostChange = (field, value) => {
    // Allow empty value or numbers up to 7 digits
    if (value === "" || /^\d{0,7}$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        [field]: value === "" ? "" : value,
      }));

      // Clear error when field is updated
      if (errors[field]) {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[field];
          return newErrors;
        });
      }
    }
  };
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when field is updated
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };
  const handleNumericChange = (field, value) => {
    if (value === "" || /^\d+$/.test(value)) {
      setFormData((prev) => {
        const updatedData = {
          ...prev,
          [field]: value,
        };

        // Automatically calculate total_toilets when functional or non-functional changes
        if (
          field === "toilets_functional" ||
          field === "toilets_nonfunctional"
        ) {
          const functional =
            field === "toilets_functional" ? value : prev.toilets_functional;
          const nonFunctional =
            field === "toilets_nonfunctional"
              ? value
              : prev.toilets_nonfunctional;

          const total =
            (parseInt(functional) || 0) + (parseInt(nonFunctional) || 0);
          updatedData.total_toilets = total.toString();
        }

        return updatedData;
      });

      // Clear error when field is updated
      if (errors[field]) {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[field];
          return newErrors;
        });
      }
    }
  };

  const handleUpdate = async () => {
    setIsUpdating(true);
    setErrors({});

    try {
      await validationSchema.validate(formData, { abortEarly: false });

      // Prepare the data for API
      const updatePayload = {
        building_ownership: formData.building_ownership,
        structure_type: formData.structure_type,
        condition: formData.condition,
        total_rooms: parseInt(formData.total_rooms) || 0,
        total_classrooms: parseInt(formData.classrooms) || 0,
        classrooms_functional: parseInt(formData.classrooms_in_use) || 0,
        classrooms_functional_repairable:
          formData.classrooms_in_use_repairable === "Yes",
        classrooms_functional_repair_cost:
          formData.classrooms_in_use_cost || "0.00",
        classrooms_non_functional:
          parseInt(formData.classrooms_nonfunctional) || 0,
        classrooms_non_functional_repairable:
          formData.classrooms_nonfunctional_repairable === "Yes",
        classrooms_non_functional_repair_cost:
          formData.classrooms_nonfunctional_cost || "0.00",
        classes_in_open: formData.classes_in_open === "Yes",
        classes_in_open_count: parseInt(formData.classes_in_open_count) || 0,
        boundary_wall: formData.boundary_wall === "Yes",
        boundary_wall_repairable: formData.boundary_wall_repairable === "Yes",
        boundary_wall_repair_cost: formData.boundary_wall_cost || "0.00",
        classroom_doors: formData.classroom_door === "Yes",
        classroom_doors_count: parseInt(formData.classroom_door_count) || 0,
        classroom_doors_repairable:
          formData.classroom_doors_repairable === "Yes",
        classroom_doors_repair_cost: formData.classroom_door_cost || "0.00",
        classroom_windows: formData.classroom_windows === "Yes",
        classroom_windows_count:
          parseInt(formData.classroom_windows_count) || 0,
        classroom_windows_repair_cost:
          formData.classroom_windows_cost || "0.00",
        electricity_available: formData.electricity === "Yes",
        electricity_connection_type: formData.electricity_connection,
        water_source: formData.water_source,
        water_storage_type: formData.water_storage,
        water_storage_type_other: formData.water_storage_other,
        water_available_year_round: formData.year_round_water === "Yes",
        handwashing_facility: formData.handwashing_facility === "Yes",
        handwashing_functional:
          formData.handwashing_status === "Functional"
            ? "Functional"
            : formData.handwashing_status === "Non-Functional"
            ? "Non-Functional"
            : null,

        separate_girls_latrines: formData.girls_latrines === "Yes",
        total_toilets: parseInt(formData.total_toilets) || 0,
        functional_toilets: parseInt(formData.toilets_functional) || 0,
        non_functional_toilets: parseInt(formData.toilets_nonfunctional) || 0,
        toilets_repair_cost: formData.toilets_repair_cost || "0.00",
        drainage: formData.drainage,
        ventilation_lighting: formData.ventilation,
        furniture_ratio: formData.furniture_ratio,
        board_types: formData.board_type.join(","),
        fire_safety: formData.fire_safety.join(","),
        first_aid_box: formData.first_aid === "Yes",
        first_aid_supplies: formData.first_aid_status,
        classroom_windows_repairable:
          formData.classroom_windows_repairable === "Yes",
        classroom_windows_repair_cost:
          formData.classroom_windows_cost || "0.00",
      };

      // Call the combined update API
      const response = await fetchData(
        `school-combined-update/${data.school_profile_id}`,
        "PUT",
        { school_infrastructure: JSON.stringify(updatePayload) },
        { "Content-Type": "application/json" }
      );

      if (response.success) {
        toast.success("Infrastructure data updated successfully!");
        if (onUpdate) {
          onUpdate(); // Refresh parent component if needed
        }
      } else {
        toast.error(response.message || "Failed to update infrastructure data");
      }
    } catch (error) {
      if (error.inner) {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
        // Removed the redundant toast notification here
      } else {
        toast.error("Error updating infrastructure data");
        console.error("Update error:", error);
      }
    } finally {
      setIsUpdating(false);
    }
  };

  // dropdown options
  const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  const buildingOwnershipOptions = [
    { label: "Govt", value: "Govt" },
    { label: "Rented", value: "Rented" },
    { label: "Community", value: "Community" },
    { label: "Donated", value: "Donated" },
  ];

  const structureTypeOptions = [
    { label: "RCC", value: "RCC" },
    { label: "Semi-pacca", value: "Semi-pacca" },
    { label: "Mud", value: "Mud" },
    { label: "Hut", value: "Hut" },
  ];

  const conditionOptions = [
    { label: "Excellent", value: "Excellent" },
    { label: "Good", value: "Good" },
    { label: "Minor Repairs", value: "Minor Repairs" },
    { label: "Major Repairs", value: "Major Repairs" },
    { label: "Dangerous", value: "Dangerous" },
  ];

  const electricityConnOptions = [
    { label: "Legal", value: "Legal" },
    { label: "Illegal Connection", value: "Illegal Connection" },
  ];

  const waterSourceOptions = [
    { label: "Bore", value: "Bore" },
    { label: "Tap", value: "Tap" },
    { label: "Tanker", value: "Tanker" },
    { label: "None", value: "None" },
  ];

  const waterStorageOptions = [
    { label: "Water Tank", value: "Water Tank" },
    { label: "Plastic Drum/tank", value: "Plastic Drum/tank" },
    { label: "No any", value: "No any" },
    { label: "Others", value: "Others" },
  ];

  const drainageOptions = [
    { label: "Proper", value: "Proper" },
    { label: "Improper", value: "Improper" },
    { label: "None", value: "None" },
  ];

  const ventilationOptions = [
    { label: "Adequate", value: "Adequate" },
    { label: "Poor", value: "Poor" },
  ];

  const furnitureOptions = [
    { label: "None", value: "None" },
    { label: "Few", value: "Few" },
    { label: "Some", value: "Some" },
    { label: "All Students Covered", value: "All Students Covered" },
  ];

  const boardOptions = [
    { label: "Whiteboard", value: "Whiteboard" },
    { label: "Blackboard", value: "Blackboard" },
    { label: "None", value: "None" },
  ];

  const fireSafetyOptions = [
    { label: "Extinguisher", value: "Extinguisher" },
    { label: "Exit Plan", value: "Exit Plan" },
    { label: "Fire Alarm", value: "Fire Alarm" },
    { label: "None", value: "None" },
  ];

  return (
    <>
      {/* <div className="flex justify-between items-center mb-6"> */}
      <div className="flex justify-between items-center mb-6">
        {isDqaApproved && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Infrastructure & Physical Environment
            </h2>
            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
              Approved from DQA
            </span>
          </>
        )}
        {isDqaRejected && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Infrastructure & Physical Environment
            </h2>
            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
              Rejected from DQA
            </span>
          </>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* </div> */}
        {/* Building Ownership */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Building Ownership"
            options={buildingOwnershipOptions}
            value={formData.building_ownership}
            onChange={(val) => handleChange("building_ownership", val)}
          />
          {errors.building_ownership && (
            <p className="text-red-500 text-xs">{errors.building_ownership}</p>
          )}
        </div>

        {/* Structure Type */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Structure Type"
            options={structureTypeOptions}
            value={formData.structure_type}
            onChange={(val) => handleChange("structure_type", val)}
          />
          {errors.structure_type && (
            <p className="text-red-500 text-xs">{errors.structure_type}</p>
          )}
        </div>

        {/* Condition */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Condition"
            options={conditionOptions}
            value={formData.condition}
            onChange={(val) => handleChange("condition", val)}
          />
          {errors.condition && (
            <p className="text-red-500 text-xs">{errors.condition}</p>
          )}
        </div>

        {/* Rooms */}
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Total no of Rooms"
            type="number"
            value={formData.total_rooms}
            onChange={(e) => handleNumericChange("total_rooms", e.target.value)}
          />
          {errors.total_rooms && (
            <p className="text-red-500 text-xs">{errors.total_rooms}</p>
          )}
        </div>

        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Total no of Classrooms"
            type="number"
            value={formData.classrooms}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d{0,2}$/.test(val)) {
                handleNumericChange("classrooms", val);
              }
            }}
          />
          {errors.classrooms && (
            <p className="text-red-500 text-xs">{errors.classrooms}</p>
          )}
        </div>

        {/* Classrooms in use with repairable option */}
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Functional Classrooms in Use functional"
            type="number"
            value={formData.classrooms_in_use}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d{0,2}$/.test(val)) {
                handleNumericChange("classrooms_in_use", val);
              }
            }}
          />
          {errors.classrooms_in_use && (
            <p className="text-red-500 text-xs">{errors.classrooms_in_use}</p>
          )}
        </div>

        {/* Non-functional classrooms with repairable option */}
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Classrooms (Non-Functional)"
            type="number"
            value={formData.classrooms_nonfunctional}
            onChange={(e) =>
              handleNumericChange("classrooms_nonfunctional", e.target.value)
            }
          />
          {errors.classrooms_nonfunctional && (
            <p className="text-red-500 text-xs">
              {errors.classrooms_nonfunctional}
            </p>
          )}
        </div>

        {formData.classrooms_in_use > 0 && (
          <>
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label=" Functional Classrooms in Use Repairable?"
                options={yesNoOptions}
                value={formData.classrooms_in_use_repairable}
                onChange={(val) =>
                  handleChange("classrooms_in_use_repairable", val)
                }
              />
            </div>
            {formData.classrooms_in_use_repairable === "Yes" && (
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Functional Classrooms Est. Repair Cost"
                  type="number"
                  value={formData.classrooms_in_use_cost}
                  onChange={(e) =>
                    handleCostChange("classrooms_in_use_cost", e.target.value)
                  }
                />
                {errors.classrooms_in_use_cost && (
                  <p className="text-red-500 text-xs">
                    {errors.classrooms_in_use_cost}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {formData.classrooms_nonfunctional > 0 && (
          <>
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label="Non-Functional Classrooms Repairable?"
                options={yesNoOptions}
                value={formData.classrooms_nonfunctional_repairable}
                onChange={(val) =>
                  handleChange("classrooms_nonfunctional_repairable", val)
                }
              />
            </div>
            {formData.classrooms_nonfunctional_repairable === "Yes" && (
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Non-Functional Est. Repair Cost"
                  type="number"
                  value={formData.classrooms_nonfunctional_cost}
                  onChange={(e) =>
                    handleCostChange(
                      "classrooms_nonfunctional_cost",
                      e.target.value
                    )
                  }
                />
                {errors.classrooms_nonfunctional_cost && (
                  <p className="text-red-500 text-xs">
                    {errors.classrooms_nonfunctional_cost}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Classes held in open */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Classes held in open/veranda"
            options={yesNoOptions}
            value={formData.classes_in_open}
            onChange={(val) => handleChange("classes_in_open", val)}
          />
          {errors.classes_in_open && (
            <p className="text-red-500 text-xs">{errors.classes_in_open}</p>
          )}
        </div>

        {formData.classes_in_open === "Yes" && (
          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="How many Classes held in open?"
              type="number"
              value={formData.classes_in_open_count}
              onChange={(e) =>
                handleNumericChange("classes_in_open_count", e.target.value)
              }
            />
          </div>
        )}

        {/* Boundary wall */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Boundary Wall"
            options={yesNoOptions}
            value={formData.boundary_wall}
            onChange={(val) => handleChange("boundary_wall", val)}
          />
          {errors.boundary_wall && (
            <p className="text-red-500 text-xs">{errors.boundary_wall}</p>
          )}
        </div>

        {formData.boundary_wall === "Yes" && (
          <>
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label="Boundary Wall Repairable?"
                options={yesNoOptions}
                value={formData.boundary_wall_repairable}
                onChange={(val) =>
                  handleChange("boundary_wall_repairable", val)
                }
              />
              {errors.boundary_wall_repairable && (
                <p className="text-red-500 text-xs">
                  {errors.boundary_wall_repairable}
                </p>
              )}
            </div>
            {formData.boundary_wall_repairable === "Yes" && (
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Boundary Wall Estimated Cost"
                  type="number"
                  value={formData.boundary_wall_cost}
                  onChange={(e) =>
                    handleCostChange("boundary_wall_cost", e.target.value)
                  }
                />
                {errors.boundary_wall_cost && (
                  <p className="text-red-500 text-xs">
                    {errors.boundary_wall_cost}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Doors */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Classroom Door"
            options={yesNoOptions}
            value={formData.classroom_door}
            onChange={(val) => handleChange("classroom_door", val)}
          />
          {errors.classroom_door && (
            <p className="text-red-500 text-xs">{errors.classroom_door}</p>
          )}
        </div>

        {formData.classroom_door === "Yes" && (
          <>
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="How many classroom door?"
                type="number"
                value={formData.classroom_door_count}
                onChange={(e) =>
                  handleNumericChange("classroom_door_count", e.target.value)
                }
              />
            </div>
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label="Classroom Door Repairable?"
                options={yesNoOptions}
                value={formData.classroom_doors_repairable}
                onChange={(val) =>
                  handleChange("classroom_doors_repairable", val)
                }
              />
            </div>
            {formData.classroom_doors_repairable === "Yes" && (
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Classroom Door Estimated Cost"
                  type="number"
                  value={formData.classroom_door_cost}
                  onChange={(e) =>
                    handleCostChange("classroom_door_cost", e.target.value)
                  }
                />
                {errors.classroom_door_cost && (
                  <p className="text-red-500 text-xs">
                    {errors.classroom_door_cost}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Windows */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Classroom Windows"
            options={yesNoOptions}
            value={formData.classroom_windows}
            onChange={(val) => handleChange("classroom_windows", val)}
          />
          {errors.classroom_windows && (
            <p className="text-red-500 text-xs">{errors.classroom_windows}</p>
          )}
        </div>

        {formData.classroom_windows === "Yes" && (
          <>
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="How many classroom windows?"
                type="number"
                value={formData.classroom_windows_count}
                onChange={(e) =>
                  handleNumericChange("classroom_windows_count", e.target.value)
                }
              />
            </div>
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label="Classroom Windows Repairable?"
                options={yesNoOptions}
                value={formData.classroom_windows_repairable}
                onChange={(val) =>
                  handleChange("classroom_windows_repairable", val)
                }
              />
              {errors.classroom_windows_repairable && (
                <p className="text-red-500 text-xs">
                  {errors.classroom_windows_repairable}
                </p>
              )}
            </div>

            {formData.classroom_windows_repairable === "Yes" && (
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Est. Repair Cost"
                  type="number"
                  value={formData.classroom_windows_cost}
                  onChange={(e) =>
                    handleCostChange("classroom_windows_cost", e.target.value)
                  }
                />
                {errors.classroom_windows_cost && (
                  <p className="text-red-500 text-xs">
                    {errors.classroom_windows_cost}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Electricity */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Electricity Available"
            options={yesNoOptions}
            value={formData.electricity}
            onChange={(val) => handleChange("electricity", val)}
          />
          {errors.electricity && (
            <p className="text-red-500 text-xs">{errors.electricity}</p>
          )}
        </div>

        {formData.electricity === "Yes" && (
          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Electricity Connection Type"
              options={electricityConnOptions}
              value={formData.electricity_connection}
              onChange={(val) => handleChange("electricity_connection", val)}
            />
            {errors.electricity_connection && (
              <p className="text-red-500 text-xs">
                {errors.electricity_connection}
              </p>
            )}
          </div>
        )}

        {/* Water */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Water Source"
            options={waterSourceOptions}
            value={formData.water_source}
            onChange={(val) => handleChange("water_source", val)}
          />
          {errors.water_source && (
            <p className="text-red-500 text-xs">{errors.water_source}</p>
          )}
        </div>

        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Water Storage Type"
            options={waterStorageOptions}
            value={formData.water_storage}
            onChange={(val) => handleChange("water_storage", val)}
          />
          {errors.water_storage && (
            <p className="text-red-500 text-xs">{errors.water_storage}</p>
          )}
        </div>

        {formData.water_storage === "Others" && (
          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Please specify"
              value={formData.water_storage_other}
              onChange={(e) =>
                handleChange("water_storage_other", e.target.value)
              }
            />
            {errors.water_storage_other && (
              <p className="text-red-500 text-xs">
                {errors.water_storage_other}
              </p>
            )}
          </div>
        )}

        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Year-Round Water Availability"
            options={yesNoOptions}
            value={formData.year_round_water}
            onChange={(val) => handleChange("year_round_water", val)}
          />
          {errors.year_round_water && (
            <p className="text-red-500 text-xs">{errors.year_round_water}</p>
          )}
        </div>

        {/* Handwashing */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Handwashing Facility near Latrine"
            options={yesNoOptions}
            value={formData.handwashing_facility}
            onChange={(val) => handleChange("handwashing_facility", val)}
          />
          {errors.handwashing_facility && (
            <p className="text-red-500 text-xs">
              {errors.handwashing_facility}
            </p>
          )}
        </div>

        {formData.handwashing_facility === "Yes" && (
          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Handwashing Facility Status"
              options={[
                { label: "Functional", value: "Functional" },
                { label: "Non-Functional", value: "Non-Functional" },
              ]}
              value={formData.handwashing_status}
              onChange={(val) => handleChange("handwashing_status", val)}
            />
            {errors.handwashing_status && (
              <p className="text-red-500 text-xs">
                {errors.handwashing_status}
              </p>
            )}
          </div>
        )}

        {/* Toilets */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Separate Latrines for Girls"
            options={yesNoOptions}
            value={formData.girls_latrines}
            onChange={(val) => handleChange("girls_latrines", val)}
          />
          {errors.girls_latrines && (
            <p className="text-red-500 text-xs">{errors.girls_latrines}</p>
          )}
        </div>

        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Functional Toilets"
            type="number"
            value={formData.toilets_functional}
            onChange={(e) =>
              handleNumericChange("toilets_functional", e.target.value)
            }
          />
          {errors.toilets_functional && (
            <p className="text-red-500 text-xs">{errors.toilets_functional}</p>
          )}
        </div>

        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Non-Functional Toilets"
            type="number"
            value={formData.toilets_nonfunctional}
            onChange={(e) =>
              handleNumericChange("toilets_nonfunctional", e.target.value)
            }
          />
          {errors.toilets_nonfunctional && (
            <p className="text-red-500 text-xs">
              {errors.toilets_nonfunctional}
            </p>
          )}
        </div>

        <div>
          <ThinTextField
            label="Total Toilets "
            type="number"
            value={formData.total_toilets}
            disabled={true} // Make it read-only
          />
          {errors.total_toilets && (
            <p className="text-red-500 text-xs">{errors.total_toilets}</p>
          )}
        </div>

        {formData.toilets_nonfunctional > 0 && (
          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Repair Cost"
              type="number"
              value={formData.toilets_repair_cost}
              onChange={(e) =>
                handleCostChange("toilets_repair_cost", e.target.value)
              }
            />
            {errors.toilets_repair_cost && (
              <p className="text-red-500 text-xs">
                {errors.toilets_repair_cost}
              </p>
            )}
          </div>
        )}

        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Drainage around Toilets"
            options={drainageOptions}
            value={formData.drainage}
            onChange={(val) => handleChange("drainage", val)}
          />
          {errors.drainage && (
            <p className="text-red-500 text-xs">{errors.drainage}</p>
          )}
        </div>

        {/* Ventilation */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Ventilation / Lighting"
            options={ventilationOptions}
            value={formData.ventilation}
            onChange={(val) => handleChange("ventilation", val)}
          />
          {errors.ventilation && (
            <p className="text-red-500 text-xs">{errors.ventilation}</p>
          )}
        </div>

        {/* Furniture */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Furniture Ratio"
            options={furnitureOptions}
            value={formData.furniture_ratio}
            onChange={(val) => handleChange("furniture_ratio", val)}
          />
          {errors.furniture_ratio && (
            <p className="text-red-500 text-xs">{errors.furniture_ratio}</p>
          )}
        </div>

        {/* Boards */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Board Types
          </label>
          <Select disabled={isDqaApproved || isDqaRejected}
            isMulti
            options={boardOptions}
            value={boardOptions.filter((o) =>
              formData.board_type?.includes(o.value)
            )}
            onChange={(selected) =>
              handleChange(
                "board_type",
                selected ? selected.map((s) => s.value) : []
              )
            }
            placeholder="Select Board Types..."
            className="basic-multi-select"
            classNamePrefix="select"
          />
          {errors.board_type && (
            <p className="text-red-500 text-xs">{errors.board_type}</p>
          )}
        </div>

        {/* Fire Safety */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Fire Safety
          </label>
          <Select disabled={isDqaApproved || isDqaRejected}
            isMulti
            options={fireSafetyOptions}
            value={fireSafetyOptions.filter((o) =>
              formData.fire_safety?.includes(o.value)
            )}
            onChange={(selected) =>
              handleChange(
                "fire_safety",
                selected ? selected.map((s) => s.value) : []
              )
            }
            placeholder="Select Fire Safety..."
            className="basic-multi-select"
            classNamePrefix="select"
          />
          {errors.fire_safety && (
            <p className="text-red-500 text-xs">{errors.fire_safety}</p>
          )}
        </div>

        {/* First Aid */}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="First Aid Box"
            options={yesNoOptions}
            value={formData.first_aid}
            onChange={(val) => handleChange("first_aid", val)}
          />
          {errors.first_aid && (
            <p className="text-red-500 text-xs">{errors.first_aid}</p>
          )}
        </div>

        {formData.first_aid === "Yes" && (
          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="First Aid Supplies Status"
              value={formData.first_aid_status}
              onChange={(e) => handleChange("first_aid_status", e.target.value)}
            />
          </div>
        )}
      </div>
      {!isDqaApproved && !isDqaRejected ? (
        <div className="mt-8 flex justify-end">
          <button
            type="button"
            onClick={handleUpdate}
            disabled={isUpdating}
            className={`${
              isUpdating
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-teal-600 hover:bg-teal-700"
            } text-white px-4 py-2 rounded-lg transition duration-200 font-medium`}
          >
            {isUpdating ? "Updating..." : "Update"}
          </button>
        </div>
      ) : (
        <div className=""></div>
      )}
    </>
  );
};

export default InfrastructureForm;
